/**
 * Every key an object carries that its allowed list does not, in the object's own key order.
 *
 * The sibling `describeUnknownKey` reports the FIRST offender, which is what a validator wants when
 * it fails on the first problem and hands the author one message. A fail-closed sanitizer wants the
 * whole list instead: the author needs every unclassified field at once, not one per publish
 * attempt. Both read the same rule from here so the two can never disagree about what "unknown"
 * means.
 */

const collectUnknownKeys = ({ value, allowed }) => {
  if (!value || typeof value !== 'object') {
    return [];
  }

  return Object.keys(value).filter((key) => !allowed.includes(key));
};

export default collectUnknownKeys;
